<template>
    <Header></Header>
    <Left></Left>
    <section class="container">
        <div>
            <div class="area_title">
                <p>예방홍보네트워크활동 통계</p>
                <div class="area_button">
                    <button type="button" @click="downloadFile">
                        <img src="img/excel.png" />
                        <span>Excel 다운</span>
                    </button>
                </div>
            </div>
            <div class="area_body">
                <div class="area_section">
                    <div class="area_search">
                        <div>
                            <label>작성일</label>
                            <div>
                                <div class="datepicker"><input type="date" id="startDate" v-model="state.startDate" @change="changeStartDate" /></div>
                                <span>~</span>
                                <div class="datepicker"><input type="date" id="endDate" v-model="state.endDate" @change="changeEndDate" /></div>
                                <button
                                    type="button"
                                    @click="
                                        setDateToToday();
                                        fnGetData();
                                    "
                                >
                                    오늘날짜
                                </button>
                            </div>
                        </div>

                        <div class="area_button">
                            <button
                                type="button"
                                @click="
                                    reset();
                                    fnGetData();
                                "
                            >
                                초기화
                            </button>
                            <button type="button" @click="fnGetData()">검색</button>
                        </div>
                    </div>
                </div>

                <template v-if="!(state.data != null && state.data.length > 0)">
                    <Spinner></Spinner>
                </template>
                <div class="area_section" v-else>
                    <div class="area_contents">
                        <div class="area_contents_title">
                            <p>세부항목</p>
                        </div>

                        <div class="area_contents_body">
                            <table class="areaGrid">
                                <thead>
                                    <tr>
                                        <th scope="col">온라인상담</th>
                                        <th scope="col">아웃리치</th>
                                        <th scope="col">성매매예방교육</th>
                                        <th scope="col">캠페인</th>
                                        <th scope="col">이벤트성 기획행사</th>
                                        <th scope="col">기관연대(방문)</th>
                                        <th scope="col">기관연대(내방)</th>
                                        <th scope="col" id="last_th">총합</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(2, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(3, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(4, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(104, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(5, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(6, state.data)) }}</td>
                                        <td class="last_line">
                                            {{
                                                CommonUtils.numberFormat(
                                                    CommonUtils.getCntByCn(1, state.data) +
                                                        CommonUtils.getCntByCn(2, state.data) +
                                                        CommonUtils.getCntByCn(3, state.data) +
                                                        CommonUtils.getCntByCn(4, state.data) +
                                                        CommonUtils.getCntByCn(104, state.data) +
                                                        CommonUtils.getCntByCn(5, state.data) +
                                                        CommonUtils.getCntByCn(6, state.data),
                                                )
                                            }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="area_contents">
                        <div class="area_contents_title">
                            <p>온라인상담</p>
                        </div>

                        <div class="area_contents_body">
                            <table class="areaGrid">
                                <thead>
                                    <tr>
                                        <th scope="col">실시횟수</th>
                                        <th scope="col">홍보횟수</th>
                                        <th scope="col">상담횟수</th>
                                        <th scope="col">홍보인원</th>
                                        <th scope="col">상담인원</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(8, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(102, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(103, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(9, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(10, state.data)) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="area_contents">
                        <div class="area_contents_title">
                            <p>온라인상담 상담인원</p>
                        </div>

                        <div class="area_contents_body">
                            <table class="areaGrid">
                                <thead>
                                    <tr>
                                        <th scope="col">일반인</th>
                                        <th scope="col">관련기관실무자</th>
                                        <template v-if="Number(state.startDate.substring(0, 4)) < 2019">
                                            <th scope="col">업소여성</th>
                                        </template>
                                        <template v-else>
                                            <th scope="col">성매매노출여성</th>
                                        </template>
                                        <th scope="col">위기청소년</th>
                                        <th scope="col">성구매자</th>
                                        <th scope="col">기타</th>
                                        <th scope="col">총합계</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(11, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(12, state.data)) }}</td>
                                        <template v-if="Number(state.startDate.substring(0, 4)) < 2019">
                                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(13, state.data)) }}</td>
                                        </template>
                                        <template v-else>
                                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(256, state.data)) }}</td>
                                        </template>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(14, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(15, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(16, state.data)) }}</td>
                                        <td class="last_line">
                                            <template v-if="Number(state.startDate.substring(0, 4)) < 2019">
                                                {{
                                                    CommonUtils.numberFormat(
                                                        CommonUtils.getCntByCn(11, state.data) +
                                                            CommonUtils.getCntByCn(12, state.data) +
                                                            CommonUtils.getCntByCn(13, state.data) +
                                                            CommonUtils.getCntByCn(14, state.data) +
                                                            CommonUtils.getCntByCn(15, state.data) +
                                                            CommonUtils.getCntByCn(16, state.data),
                                                    )
                                                }}
                                            </template>
                                            <template v-else>
                                                {{
                                                    CommonUtils.numberFormat(
                                                        CommonUtils.getCntByCn(11, state.data) +
                                                            CommonUtils.getCntByCn(12, state.data) +
                                                            CommonUtils.getCntByCn(256, state.data) +
                                                            CommonUtils.getCntByCn(14, state.data) +
                                                            CommonUtils.getCntByCn(15, state.data) +
                                                            CommonUtils.getCntByCn(16, state.data),
                                                    )
                                                }}
                                            </template>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="area_contents">
                        <div class="area_contents_title">
                            <p>아웃리치</p>
                        </div>

                        <div class="area_contents_body">
                            <table class="areaGrid">
                                <thead>
                                    <tr>
                                        <th scope="col">실시횟수</th>
                                        <!--<th scope="col">대상인원</th>-->
                                        <th scope="col">홍보인원</th>
                                        <th scope="col">상담인원</th>
                                        <th scope="col">업소수</th>
                                        <th scope="col">홍보물품수</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(23, state.data)) }}</td>
                                        <!--<td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(24, state.data)) }}</td>-->
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(110, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(111, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(25, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(26, state.data)) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="area_contents">
                        <div class="area_contents_title">
                            <p>아웃리치 상담인원</p>
                        </div>

                        <div class="area_contents_body">
                            <table class="areaGrid">
                                <thead>
                                    <tr>
                                        <th scope="col">일반인</th>
                                        <th scope="col">관련기관실무자</th>
                                        <template v-if="Number(state.startDate.substring(0, 4)) < 2019">
                                            <th scope="col">업소여성</th>
                                        </template>
                                        <template v-else>
                                            <th scope="col">성매매노출여성</th>
                                        </template>
                                        <th scope="col">위기청소년</th>
                                        <th scope="col">성구매자</th>
                                        <th scope="col" id="last_th">기타</th>
                                        <th scope="col">총합계</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(27, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(28, state.data)) }}</td>

                                        <template v-if="Number(state.startDate.substring(0, 4)) < 2019">
                                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(29, state.data)) }}</td>
                                        </template>
                                        <template v-else>
                                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(257, state.data)) }}</td>
                                        </template>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(30, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(31, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(32, state.data)) }}</td>
                                        <td class="last_line">
                                            <template v-if="Number(state.startDate.substring(0, 4)) < 2019">
                                                {{
                                                    CommonUtils.numberFormat(
                                                        CommonUtils.getCntByCn(27, state.data) +
                                                            CommonUtils.getCntByCn(28, state.data) +
                                                            CommonUtils.getCntByCn(29, state.data) +
                                                            CommonUtils.getCntByCn(30, state.data) +
                                                            CommonUtils.getCntByCn(31, state.data) +
                                                            CommonUtils.getCntByCn(32, state.data),
                                                    )
                                                }}
                                            </template>
                                            <template v-else>
                                                {{
                                                    CommonUtils.numberFormat(
                                                        CommonUtils.getCntByCn(27, state.data) +
                                                            CommonUtils.getCntByCn(28, state.data) +
                                                            CommonUtils.getCntByCn(257, state.data) +
                                                            CommonUtils.getCntByCn(30, state.data) +
                                                            CommonUtils.getCntByCn(31, state.data) +
                                                            CommonUtils.getCntByCn(32, state.data),
                                                    )
                                                }}
                                            </template>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="area_contents">
                        <div class="area_contents_title">
                            <p>아웃리치 방법</p>
                        </div>

                        <div class="area_contents_body">
                            <table class="areaGrid">
                                <thead>
                                    <tr>
                                        <th scope="col">자료배포및부착</th>
                                        <th scope="col">물품배포</th>
                                        <th scope="col">대중매체 활용 인터뷰 및 출연</th>
                                        <th scope="col">이벤트성 기획행사</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(34, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(35, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(36, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(37, state.data)) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="area_contents">
                        <div class="area_contents_title">
                            <p>성매매예방교육</p>
                        </div>

                        <div class="area_contents_body">
                            <table class="areaGrid">
                                <thead>
                                    <tr>
                                        <th scope="col">실시횟수</th>
                                        <!--<th scope="col">대상인원</th>-->
                                        <th scope="col">홍보인원</th>
                                        <th scope="col">상담인원</th>
                                        <th scope="col">홍보물품수</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(39, state.data)) }}</td>
                                        <!--<td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(40, state.data)) }}</td>-->
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(112, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(113, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(41, state.data)) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="area_contents">
                        <div class="area_contents_title">
                            <p>성매매예방교육 대상</p>
                        </div>

                        <div class="area_contents_body">
                            <table class="areaGrid">
                                <thead>
                                    <tr>
                                        <th scope="col">정부/지자체</th>
                                        <th scope="col">공공기관</th>
                                        <th scope="col">유관기관</th>
                                        <th scope="col">재발방지 교육(여성)</th>
                                        <th scope="col">성구매자재범 방지교육 (보호관찰소 존스쿨 교육)</th>
                                        <th scope="col">검ㆍ경등 수사기관</th>
                                        <th scope="col">군대</th>
                                        <th scope="col">학교</th>
                                        <th scope="col">민간기관 및 사기업 등</th>
                                        <th scope="col" id="last_th">기타</th>
                                        <th scope="col">총합계</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(42, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(43, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(201, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(202, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(44, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(45, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(46, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(47, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(48, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(49, state.data)) }}</td>
                                        <td class="last_line">
                                            {{
                                                CommonUtils.numberFormat(
                                                    CommonUtils.getCntByCn(42, state.data) +
                                                        CommonUtils.getCntByCn(43, state.data) +
                                                        CommonUtils.getCntByCn(201, state.data) +
                                                        CommonUtils.getCntByCn(202, state.data) +
                                                        CommonUtils.getCntByCn(44, state.data) +
                                                        CommonUtils.getCntByCn(45, state.data) +
                                                        CommonUtils.getCntByCn(46, state.data) +
                                                        CommonUtils.getCntByCn(47, state.data) +
                                                        CommonUtils.getCntByCn(48, state.data) +
                                                        CommonUtils.getCntByCn(49, state.data),
                                                )
                                            }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="area_contents">
                        <div class="area_contents_title">
                            <p>성매매예방교육 방법</p>
                        </div>

                        <div class="area_contents_body">
                            <table class="areaGrid">
                                <thead>
                                    <tr>
                                        <th scope="col">자료배포및부착</th>
                                        <th scope="col">물품배포</th>
                                        <th scope="col">대중매체 활용 인터뷰 및 출연</th>
                                        <th scope="col">이벤트성 기획행사</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(51, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(52, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(53, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(54, state.data)) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="area_contents">
                        <div class="area_contents_title">
                            <p>캠페인</p>
                        </div>

                        <div class="area_contents_body">
                            <table class="areaGrid">
                                <thead>
                                    <tr>
                                        <th scope="col">실시횟수</th>
                                        <!--<th scope="col">대상인원</th>-->
                                        <th scope="col">홍보인원</th>
                                        <th scope="col">상담인원</th>
                                        <th scope="col">홍보물품수</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(56, state.data)) }}</td>
                                        <!--<td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(57, state.data)) }}</td>-->
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(114, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(115, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(58, state.data)) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="area_contents">
                        <div class="area_contents_title">
                            <p>캠페인 대상</p>
                        </div>

                        <div class="area_contents_body">
                            <table class="areaGrid">
                                <thead>
                                    <tr>
                                        <th scope="col">일반인</th>
                                        <th scope="col">관련기관실무자</th>
                                        <!-- <th scope="col"><%if sYear < "2019" then echo "업소여성" else echo "성매매노출여성" end if%></th> -->
                                        <template v-if="Number(state.startDate.substring(0, 4)) < 2019">
                                            <th scope="col">업소여성</th>
                                        </template>
                                        <template v-else>
                                            <th scope="col">성매매노출여성</th>
                                        </template>
                                        <th scope="col">위기청소년</th>
                                        <th scope="col">성구매자</th>
                                        <th scope="col" id="last_th">기타</th>
                                        <th scope="col">총합계</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(59, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(60, state.data)) }}</td>
                                        <!-- <td class="last_line">
                                            <% if sYear < "2019" then echo formatNum((CommonUtils.getCntByCn(61, state.data))) else echo
                                            formatNum((CommonUtils.getCntByCn(258, state.data))) end if %>
                                        </td> -->
                                        <template v-if="Number(state.startDate.substring(0, 4)) < 2019">
                                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(61, state.data)) }}</td>
                                        </template>
                                        <template v-else>
                                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(258, state.data)) }}</td>
                                        </template>

                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(62, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(63, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(64, state.data)) }}</td>
                                        <td class="last_line">
                                            <template v-if="Number(state.startDate.substring(0, 4)) < 2019">
                                                {{
                                                    CommonUtils.numberFormat(
                                                        CommonUtils.getCntByCn(59, state.data) +
                                                            CommonUtils.getCntByCn(60, state.data) +
                                                            CommonUtils.getCntByCn(61, state.data) +
                                                            CommonUtils.getCntByCn(62, state.data) +
                                                            CommonUtils.getCntByCn(63, state.data) +
                                                            CommonUtils.getCntByCn(64, state.data),
                                                    )
                                                }}
                                            </template>
                                            <template v-else>
                                                {{
                                                    CommonUtils.numberFormat(
                                                        CommonUtils.getCntByCn(59, state.data) +
                                                            CommonUtils.getCntByCn(60, state.data) +
                                                            CommonUtils.getCntByCn(258, state.data) +
                                                            CommonUtils.getCntByCn(62, state.data) +
                                                            CommonUtils.getCntByCn(63, state.data) +
                                                            CommonUtils.getCntByCn(64, state.data),
                                                    )
                                                }}
                                            </template>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="area_contents">
                        <div class="area_contents_title">
                            <p>캠페인 방법</p>
                        </div>

                        <div class="area_contents_body">
                            <table class="areaGrid">
                                <thead>
                                    <tr>
                                        <th scope="col">자료배포및부착</th>
                                        <th scope="col">물품배포</th>
                                        <th scope="col">대중매체 활용 인터뷰 및 출연</th>
                                        <th scope="col">이벤트성 기획행사</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(66, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(67, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(68, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(69, state.data)) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="area_contents">
                        <div class="area_contents_title">
                            <p>이벤트성 기획행사</p>
                        </div>

                        <div class="area_contents_body">
                            <table class="areaGrid">
                                <thead>
                                    <tr>
                                        <th scope="col">실시횟수</th>
                                        <!--<th scope="col">대상인원</th>-->
                                        <th scope="col">홍보인원</th>
                                        <th scope="col">상담인원</th>
                                        <th scope="col">홍보물품수</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(120, state.data)) }}</td>
                                        <!--<td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(121, state.data)) }}</td>-->
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(122, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(123, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(124, state.data)) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="area_contents">
                        <div class="area_contents_title">
                            <p>이벤트성 기획행사 대상</p>
                        </div>

                        <div class="area_contents_body">
                            <table class="areaGrid">
                                <thead>
                                    <tr>
                                        <th scope="col">일반인</th>
                                        <th scope="col">관련기관실무자</th>
                                        <!-- <th scope="col"><%if sYear < "2019" then echo "업소여성" else echo "성매매노출여성" end if%></th> -->
                                        <template v-if="Number(state.startDate.substring(0, 4)) < 2019">
                                            <th scope="col">업소여성</th>
                                        </template>
                                        <template v-else>
                                            <th scope="col">성매매노출여성</th>
                                        </template>
                                        <th scope="col">위기청소년</th>
                                        <th scope="col">성구매자</th>
                                        <th scope="col" id="last_th">기타</th>
                                        <th scope="col">총합계</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(125, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(126, state.data)) }}</td>
                                        <!-- <td class="last_line">
                                            <% if sYear < "2019" then echo formatNum((CommonUtils.getCntByCn(127, state.data))) else echo
                                            formatNum((CommonUtils.getCntByCn(259, state.data))) end if %>
                                        </td> -->
                                        <template v-if="Number(state.startDate.substring(0, 4)) < 2019">
                                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(127, state.data)) }}</td>
                                        </template>
                                        <template v-else>
                                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(259, state.data)) }}</td>
                                        </template>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(128, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(129, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(130, state.data)) }}</td>
                                        <td class="last_line">
                                            <template v-if="Number(state.startDate.substring(0, 4)) < 2019">
                                                {{
                                                    CommonUtils.numberFormat(
                                                        CommonUtils.getCntByCn(125, state.data) +
                                                            CommonUtils.getCntByCn(126, state.data) +
                                                            CommonUtils.getCntByCn(127, state.data) +
                                                            CommonUtils.getCntByCn(128, state.data) +
                                                            CommonUtils.getCntByCn(129, state.data) +
                                                            CommonUtils.getCntByCn(130, state.data),
                                                    )
                                                }}
                                            </template>
                                            <template v-else>
                                                {{
                                                    CommonUtils.numberFormat(
                                                        CommonUtils.getCntByCn(125, state.data) +
                                                            CommonUtils.getCntByCn(126, state.data) +
                                                            CommonUtils.getCntByCn(259, state.data) +
                                                            CommonUtils.getCntByCn(128, state.data) +
                                                            CommonUtils.getCntByCn(129, state.data) +
                                                            CommonUtils.getCntByCn(130, state.data),
                                                    )
                                                }}
                                            </template>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="area_contents">
                        <div class="area_contents_title">
                            <p>이벤트성 기획행사 방법</p>
                        </div>

                        <div class="area_contents_body">
                            <table class="areaGrid">
                                <thead>
                                    <tr>
                                        <th scope="col">자료배포및부착</th>
                                        <th scope="col">물품배포</th>
                                        <th scope="col">대중매체 활용 인터뷰 및 출연</th>
                                        <th scope="col">이벤트성 기획행사</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(131, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(132, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(133, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(134, state.data)) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="area_contents">
                        <div class="area_contents_title">
                            <p>기관연대(방문)</p>
                        </div>

                        <div class="area_contents_body">
                            <table class="areaGrid">
                                <thead>
                                    <tr>
                                        <th scope="col">실시횟수</th>
                                        <!--<th scope="col">대상인원</th>-->
                                        <th scope="col">홍보인원</th>
                                        <th scope="col">상담인원</th>
                                        <th scope="col">홍보물품수</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(71, state.data)) }}</td>
                                        <!--<td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(72, state.data)) }}</td>-->
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(116, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(117, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(73, state.data)) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="area_contents">
                        <div class="area_contents_title">
                            <p>기관연대(방문) 대상</p>
                        </div>

                        <div class="area_contents_body">
                            <table class="areaGrid">
                                <thead>
                                    <tr>
                                        <th scope="col">일반인</th>
                                        <th scope="col">관련기관실무자</th>
                                        <!-- <th scope="col"><%if sYear < "2019" then echo "업소여성" else echo "성매매노출여성" end if%></th> -->
                                        <template v-if="Number(state.startDate.substring(0, 4)) < 2019">
                                            <th scope="col">업소여성</th>
                                        </template>
                                        <template v-else>
                                            <th scope="col">성매매노출여성</th>
                                        </template>
                                        <th scope="col">위기청소년</th>
                                        <th scope="col">성구매자</th>
                                        <th scope="col" id="last_th">기타</th>
                                        <th scope="col">총합계</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(74, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(75, state.data)) }}</td>
                                        <!-- <td class="last_line">
                                            <%if sYear < "2019" then echo formatNum((CommonUtils.getCntByCn(76, state.data))) else echo
                                            formatNum((CommonUtils.getCntByCn(260, state.data))) end if %>
                                        </td> -->
                                        <template v-if="Number(state.startDate.substring(0, 4)) < 2019">
                                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(76, state.data)) }}</td>
                                        </template>
                                        <template v-else>
                                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(260, state.data)) }}</td>
                                        </template>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(77, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(78, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(79, state.data)) }}</td>
                                        <td class="last_line">
                                            <template v-if="Number(state.startDate.substring(0, 4)) < 2019">
                                                {{
                                                    CommonUtils.numberFormat(
                                                        CommonUtils.getCntByCn(74, state.data) +
                                                            CommonUtils.getCntByCn(75, state.data) +
                                                            CommonUtils.getCntByCn(76, state.data) +
                                                            CommonUtils.getCntByCn(77, state.data) +
                                                            CommonUtils.getCntByCn(78, state.data) +
                                                            CommonUtils.getCntByCn(79, state.data),
                                                    )
                                                }}
                                            </template>
                                            <template v-else>
                                                {{
                                                    CommonUtils.numberFormat(
                                                        CommonUtils.getCntByCn(74, state.data) +
                                                            CommonUtils.getCntByCn(75, state.data) +
                                                            CommonUtils.getCntByCn(260, state.data) +
                                                            CommonUtils.getCntByCn(77, state.data) +
                                                            CommonUtils.getCntByCn(78, state.data) +
                                                            CommonUtils.getCntByCn(79, state.data),
                                                    )
                                                }}
                                            </template>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="area_contents">
                        <div class="area_contents_title">
                            <p>기관연대(방문) 방법</p>
                        </div>

                        <div class="area_contents_body">
                            <table class="areaGrid">
                                <thead>
                                    <tr>
                                        <th scope="col">자료배포및부착</th>
                                        <th scope="col">물품배포</th>
                                        <th scope="col">대중매체 활용 인터뷰 및 출연</th>
                                        <th scope="col">이벤트성 기획행사</th>
                                        <th scope="col">회의</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(81, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(82, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(83, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(84, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(100, state.data)) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="area_contents">
                        <div class="area_contents_title">
                            <p>기관연대(내방)</p>
                        </div>

                        <div class="area_contents_body">
                            <table class="areaGrid">
                                <thead>
                                    <tr>
                                        <th scope="col">실시횟수</th>
                                        <!--<th scope="col">대상인원</th>-->
                                        <th scope="col">홍보인원</th>
                                        <th scope="col">상담인원</th>
                                        <th scope="col">홍보물품수</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(86, state.data)) }}</td>
                                        <!--<td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(87, state.data)) }}</td>-->
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(118, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(119, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(88, state.data)) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="area_contents">
                        <div class="area_contents_title">
                            <p>기관연대(내방) 대상</p>
                        </div>

                        <div class="area_contents_body">
                            <table class="areaGrid">
                                <thead>
                                    <tr>
                                        <th scope="col">일반인</th>
                                        <th scope="col">관련기관실무자</th>
                                        <!-- <th scope="col"><%if sYear < "2019" then echo "업소여성" else echo "성매매노출여성" end if%></th> -->
                                        <template v-if="Number(state.startDate.substring(0, 4)) < 2019">
                                            <th scope="col">업소여성</th>
                                        </template>
                                        <template v-else>
                                            <th scope="col">성매매노출여성</th>
                                        </template>
                                        <th scope="col">위기청소년</th>
                                        <th scope="col">성구매자</th>
                                        <th scope="col" id="last_th">기타</th>
                                        <th scope="col">총합계</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(89, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(90, state.data)) }}</td>
                                        <!-- <td class="last_line">
                                            <%if sYear < "2019" then echo formatNum((CommonUtils.getCntByCn(91, state.data))) else echo
                                            formatNum((CommonUtils.getCntByCn(261, state.data))) end if %>
                                        </td> -->
                                        <template v-if="Number(state.startDate.substring(0, 4)) < 2019">
                                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(91, state.data)) }}</td>
                                        </template>
                                        <template v-else>
                                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(261, state.data)) }}</td>
                                        </template>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(92, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(93, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(94, state.data)) }}</td>
                                        <td class="last_line">
                                            <template v-if="Number(state.startDate.substring(0, 4)) < 2019">
                                                {{
                                                    CommonUtils.numberFormat(
                                                        CommonUtils.getCntByCn(89, state.data) +
                                                            CommonUtils.getCntByCn(90, state.data) +
                                                            CommonUtils.getCntByCn(91, state.data) +
                                                            CommonUtils.getCntByCn(92, state.data) +
                                                            CommonUtils.getCntByCn(93, state.data) +
                                                            CommonUtils.getCntByCn(94, state.data),
                                                    )
                                                }}
                                            </template>
                                            <template v-else>
                                                {{
                                                    CommonUtils.numberFormat(
                                                        CommonUtils.getCntByCn(89, state.data) +
                                                            CommonUtils.getCntByCn(90, state.data) +
                                                            CommonUtils.getCntByCn(261, state.data) +
                                                            CommonUtils.getCntByCn(92, state.data) +
                                                            CommonUtils.getCntByCn(93, state.data) +
                                                            CommonUtils.getCntByCn(94, state.data),
                                                    )
                                                }}
                                            </template>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="area_contents">
                        <div class="area_contents_title">
                            <p>기관연대(내방) 방법</p>
                        </div>

                        <div class="area_contents_body">
                            <table class="areaGrid">
                                <thead>
                                    <tr>
                                        <th scope="col">자료배포및부착</th>
                                        <th scope="col">물품배포</th>
                                        <th scope="col">대중매체 활용 인터뷰 및 출연</th>
                                        <th scope="col">이벤트성 기획행사</th>
                                        <th scope="col">회의</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(96, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(97, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(98, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(99, state.data)) }}</td>
                                        <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(101, state.data)) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <Spinner :is-full-page="true" v-if="state.isGlobalLoading"></Spinner>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="state.isShowModal = false"
    ></ModalDefault>
</template>
<script lang="ts" config>
    import {
        reactive,
        apiService,
        onMounted,
        Header,
        Left,
        ModalDefault,
        types,
        getMessageByCode,
        PageBtn,
        CommonUtils,
        CommonOptions,
        Counsel,
        Client,
        Year,
        Spinner,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: { Header, Left, ModalDefault, Counsel, Client, Year, Spinner },
        setup() {
            const dayAgo = new Date();

            const today = new Date();
            dayAgo.setFullYear(today.getFullYear());
            dayAgo.setMonth(0);
            dayAgo.setDate(1);

            const state = reactive({
                startDate: "" as string,
                endDate: "" as string,
                category: "" as string,
                // type: 3 as 1 | 2 | 3,
                data: [] as Array<types.statistics.StatisticsVOForApi> | null,
                isLoading: false,
                isGlobalLoading: false as boolean,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalTitle: "alert" as string,
                modalContent: "" as string,
            });

            onMounted(() => {
                state.startDate = dayAgo.toLocaleDateString("sv-SE");
                state.endDate = today.toLocaleDateString("sv-SE");

                fnGetData();
            });

            const fnGetData = async () => {
                state.isLoading = true;
                const param: types.statistics.ReqStatistics = {
                    category: state.category,
                    sex: "",
                    startDate: state.startDate,
                    endDate: state.endDate,
                    order: null,
                    page: null,
                    size: null,
                    searchType: null,
                    searchText: null,
                };
                let res: types.statistics.ResStatistics = await apiService.statistics.activity(param);

                if (res.returnCode === 0) {
                    state.data = res.data;
                } else {
                    console.error(res.description);
                }
                state.isLoading = false;
            };

            const fnGetData2 = async () => {};

            const reset = () => {
                state.startDate = dayAgo.toLocaleDateString("sv-SE");
                state.endDate = today.toLocaleDateString("sv-SE");
            };

            const setDateToToday = () => {
                state.startDate = today.toLocaleDateString("sv-SE");
                state.endDate = today.toLocaleDateString("sv-SE");
            };

            const changeStartDate = () => {
                if (state.startDate === "") {
                    state.startDate = dayAgo.toLocaleDateString("sv-SE");
                } else if (!CommonUtils.checkDateRange(state.startDate, state.endDate)) {
                    state.endDate = state.startDate;
                } else {
                    fnGetData();
                }
            };
            const changeEndDate = () => {
                if (state.startDate === "") {
                    state.startDate = state.endDate;
                } else if (!CommonUtils.checkDateRange(state.startDate, state.endDate)) {
                    state.endDate = state.startDate;
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "작성일 범위가 잘못 선택되었습니다.";
                    state.isShowModal = true;
                }
                fnGetData();
            };

            const downloadFile = async () => {
                state.isGlobalLoading = true;
                try {
                    const param: types.statistics.ReqStatisticsForExcel = {
                        category: state.category,
                        sex: "",
                        startDate: state.startDate,
                        endDate: state.endDate,
                        order: null,
                        page: null,
                        size: null,
                        searchType: null,
                        searchText: null,
                        type: 4,
                    };

                    let res = await apiService.statistics.exportExcel(param);
                    if (res && res.data) {
                        const blob = new Blob([res.data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        });
                        const disposition = res.headers["content-disposition"];
                        let fileName = "download.xlsx";
                        if (disposition) {
                            const match = disposition.match(/filename="?(.+)"?/);
                            if (match && match[1]) {
                                fileName = decodeURIComponent(match[1]);
                            }
                        }
                        const a = document.createElement("a");
                        const url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error("파일 다운로드 실패:", err);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "파일 다운로드 실패";
                    state.isShowModal = true;
                }
                state.isGlobalLoading = false;
            };

            return {
                state,
                reset,
                CommonUtils,
                CommonOptions,
                setDateToToday,
                fnGetData,
                fnGetData2,
                downloadFile,
                changeStartDate,
                changeEndDate,
            };
        },
    };
</script>
<style scoped>
    .sch_list label:last-child {
        border-right: white;
    }

    .areaGrid td {
        text-align: center;
    }
</style>
